var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJetPlusIconContentDefault = function SvgJetPlusIconContentDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M19.188 9.016h-8.204V.813H9.016v8.203H.813v1.968h8.203v8.204h1.968v-8.204h8.204z"
  })));
};
export { SvgJetPlusIconContentDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjE4NzUgOS4wMTU2MkgxMC45ODQ0VjAuODEyNUg5LjAxNTYyVjkuMDE1NjJIMC44MTI1VjEwLjk4NDRIOS4wMTU2MlYxOS4xODc1SDEwLjk4NDRWMTAuOTg0NEgxOS4xODc1VjkuMDE1NjJaIiBmaWxsPSIjMjQyRTMwIi8+Cjwvc3ZnPgo=";